<template>
  <div>
    <el-form ref="DetailForm" :model="DetailForm" label-width="110px" :rules="EditRules" style="margin-top:10px;margin-bottom:60px;">
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="名称" prop="b_name">
                <el-input v-model="DetailForm.b_name" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="对应讲述楼" prop="b_house">
                <el-input v-model="DetailForm.b_house" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="地区名称" prop="b_area">
                <el-select v-model="DetailForm.b_area" placeholder="请选择">
                <el-option
                    v-for="item in selectAreaOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="地址" prop="b_addr">
                <el-input v-model="DetailForm.b_addr" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <!-- <el-col :span="7">
            <el-form-item label="代码" prop="b_code">
                <el-input v-model="DetailForm.b_code"></el-input>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="7">
            <el-form-item label="负责人" prop="b_director">
                <el-select v-model="DetailForm.b_director" multiple placeholder="请选择">
                <el-option
                    v-for="item in selectAdminOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
                </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <!-- <el-form-item label="描述" prop="b_desc">
                <el-input type="textarea" :rows="6" v-model="DetailForm.b_desc"></el-input>
            </el-form-item> -->
            <el-form-item label="服务时间" prop="b_servertime">
                <el-input type="textarea" :rows="4" v-model="DetailForm.b_servertime" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="图片" prop="b_cover">
                <el-upload
                    disabled
                    :class="{disabled:uploadDisabled}"
                    :action="uploadAddress"
                    list-type="picture-card"
                    name="file"
                    :limit="1"
                    ref="DetailUpload"
                    :on-preview="handleDetailPreview"
                    :file-list="DetailFileList">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="DetailPreviewDialogVisible">
                    <img width="100%" :src="DetailPreviewDialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" class="row-bg">
          <el-col :span="14">
            <el-form-item label="图片宽度" prop="b_width">
                <el-input v-model="DetailForm.b_width" placeholder="格式如: 100%" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-col :span="7">
            <el-form-item label="图片X轴位置" prop="b_left">
                <el-input v-model="DetailForm.b_left" placeholder="格式如: 100%" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="图片Y轴位置" prop="b_top">
                <el-input v-model="DetailForm.b_top" placeholder="格式如: 100%" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-footer>
        <el-button type="primary" @click="goBack" size="small" icon="el-icon-arrow-left">返回</el-button>
      </el-footer>
  </div>
</template>

<script>
// 引入接口
import api from '@/api/api.js'
// 获取token
import { getToken , removeToken } from '@/utils/auth'

export default {
  name: 'componentspage1',
  data() {
      return {
        DetailForm: {
            // b_code : '',
            // b_lat : '',
            // b_director : [],
            // b_desc : '',
            b_id : '',
            b_name : '',
            b_house : '',
            b_addr : '',
            b_servertime : '',
            b_cover : '',
            b_width : '',
            b_left : '',
            b_top : '',
            // b_area : '',
            // b_lon : '',
        },
        DetailFileList : [],
        selectAdminOptions : [], // 负责人
        selectAreaOptions : [], // 地区

        uploadAddress : `${api.dev}/p/main/upload/image`,  // 上传图片的地址
        DetailPreviewDialogVisible : false,
        DetailPreviewDialogImageUrl : ''
      }
  },
  methods : {
      goBack() {
        this.$router.back(-1);
      },
      // 获取负责人
      getSelectAdmin() {
        this.$http.get(`${api.dev}/p/main/drop/selectAdmin`,{params: {access_token: getToken(), type : 0}}).then(res => {
          if(res.body.code == 200) {
            this.selectAdminOptions = res.body.content;
          }else if(res.body.code == 500) {
            this.$message({
              message: res.body.msg,
              type: 'error'
            });
            removeToken();
            setTimeout(function () {
              this.$router.push({path: '/login'});
            },2000)
          }
        })
      },
      getSelectArea() {
          this.$http.get(`${api.dev}/p/main/drop/selectArea`,{params: {access_token: getToken(), type : 0}}).then(res => {
                if(res.body.code == 200) {
                    this.selectAreaOptions = res.body.content;
                }else if(res.body.code == 500) {
                    this.$message({
                        message: res.body.msg,
                        type: 'error'
                    });
                    removeToken();
                    setTimeout(function () {
                        this.$router.push({path: '/login'});
                    },2000)
                }
          })
      },
      getInfo() {
          this.$http.get(`${api.dev}/p/main/house/select`,{params: {access_token : getToken() , b_id : this.$route.params.id}}).then(res => {
            if(res.body.code == 200) {        
                // this.DetailForm.b_code = res.body.content.house.b_code;
                // this.DetailForm.b_lat = res.body.content.house.b_lat;
                // this.DetailForm.b_director = res.body.content.house.b_director;
                // this.DetailForm.b_desc = res.body.content.house.b_desc;
                this.DetailForm.b_cover = res.body.content.house.b_cover;
                this.DetailForm.b_id = res.body.content.house.b_id;
                this.DetailForm.b_name = res.body.content.house.b_name;
                this.DetailForm.b_house = res.body.content.house.b_house;
                this.DetailForm.b_addr = res.body.content.house.b_addr;
                this.DetailForm.b_servertime = res.body.content.house.b_servertime;
                this.DetailForm.b_width = res.body.content.house.b_width;
                this.DetailForm.b_top = res.body.content.house.b_top;
                this.DetailForm.b_left = res.body.content.house.b_left;
                // this.DetailForm.b_area = res.body.content.house.b_area;
                // this.DetailForm.b_lon = res.body.content.house.b_lon;

                this.DetailFileList = [{url: `${api.address}${res.body.content.house.b_cover}`}];
            }else if(res.body.code == 500) {
                this.$message({
                    message: res.body.msg,
                    type: 'error'
                });
                removeToken();
                setTimeout(function () {
                    this.$router.push({path: '/login'});
                },2000)
            }
        })
      },
            // 放大图片
    handleDetailPreview(file) {
        this.DetailPreviewDialogVisible = true;
        this.DetailPreviewDialogImageUrl = file.url;
    },
  },
  created() {
      this.getInfo()
      this.getSelectArea()
      this.getSelectAdmin()
  },
  computed: {
        uploadDisabled:function() {
            return this.DetailForm.b_cover != ''
        },
    },
}
</script>

<style lang="stylus" scoped>
.el-footer 
    background-color #A3C0D1;
    color #333;
    line-height 60px;
    position absolute;
    width 100%;
    bottom 0;
    z-index 9999
    margin-left -15px
.el-form-item
    margin-bottom 30px
</style>



